export enum RosebudColorMap {
  /***
   * @Deprecated use KahunColorMap.PrimaryDim instead
   */
  purple2 = "#4f4f92",
  /***
   * @Deprecated use KahunColorMap.DefaultLight instead
   */
  green1 = "rgba(55, 107, 116,0.13)",
  /***
   * @Deprecated use KahunColorMap.PrimaryDim instead
   */
  green2 = "#4247c9",
  /***
   * @Deprecated use KahunColorMap.PrimaryDim instead
   */
  button = "#4247c9",
  /***
   * @Deprecated use KahunColorMap.SecondaryLight instead
   */
  red = "#b3294c",
  /***
   * @Deprecated use KahunColorMap.Accent instead
   */
  orange = "#ff9268",
  /***
   * @Deprecated use KahunColorMap.Default instead
   */
  black = "#1c1c1c",
  /***
   * @Deprecated use KahunColorMap.DefaultLight instead
   */
  gray2 = "#797879",
  /***
   * @Deprecated use KahunColorMap.DefaultLight instead
   */
  gray1 = "#4b4b4b",
  /***
   * @Deprecated use KahunColorMap.Primary instead
   */
  navy2 = "#120078",
  /***
   * @Deprecated use KahunColorMap.Secondary instead
   */
  green3 = "#00AF91",
  /***
   * @Deprecated use KahunColorMap.ActionBackground instead
   */
  parameter = "#dee7e8",
  /***
   * @Deprecated use KahunColorMap.Background instead
   */
  mainBackground = "#f8f8fa",
  /***
   * @Deprecated use KahunColorMap.Background instead
   */
  patientChartBg = "#f6feff",
  /***
   * @Deprecated use KahunColorMap.ActionBackground instead
   */
  uglyBlue4 = "rgba(52, 115, 127, 0.04)",
  /***
   * @Deprecated use KahunColorMap.ActionBackground instead
   */
  yellow = "#f5f7fe",
  /***
   * @Deprecated use KahunColorMap.Primary instead
   */
  navy = "#1C1942",
  // --- Function based colors
  /***
   * @Deprecated use KahunColorMap.DefaultLight instead
   */
  Primary = green1,
  /***
   * @Deprecated use KahunColorMap.Background instead
   */
  PrimaryLight = "#f6feff",
  /***
   * @Deprecated use KahunColorMap.PrimaryDim instead
   */
  PrimaryDark = button,
  /***
   * @Deprecated use KahunColorMap.ActionBackground instead
   */
  Secondary = "#6f9090",
  /***
   * @Deprecated use KahunColorMap.Background instead
   */
  SecondaryLight = "#f0f0f0",
  /***
   * @Deprecated use KahunColorMap.DefaultLight instead
   */
  Default = "#4b4b4b",
  /***
   * @Deprecated use KahunColorMap.DefaultLight instead
   */
  DefaultLight = "#ececf2",
  /***
   * @Deprecated use KahunColorMap.inputBorder instead
   */
  Accent = "#383874",
  /***
   * @Deprecated use KahunColorMap.inputBorder instead
   */
  AccentLight = "#4f4f92",
  /***
   * @Deprecated use KahunColorMap.Background instead
   */
  White = "#ffffff",
  /***
   * @Deprecated use KahunColorMap.DefaultLight instead
   */
  Gray = "#979797",
  /***
   * @Deprecated use KahunColorMap.ActionBackground instead
   */
  Info = yellow,
  /***
   * @Deprecated use KahunColorMap.Secondary instead
   */
  Positive = "#679a38",
  /***
   * @Deprecated use KahunColorMap.Accent instead
   */
  Warning = "#dd7256",
  /***
   * @Deprecated use KahunColorMap.ActionBackground instead
   */
  Purple = "#d7d7f9",
}
